import { cookieValue, getUser } from "./utils";
/* eslint-disable */
export const initializeTracking = () => {
  // INTERCOM
  const impersonating = cookieValue("impersonating") === "true";
  const local = window.location.hostname === "localhost";
  if (impersonating || local) return;

  const intercomIdentifyUser = (user) => {
    window.intercomSettings = {
      app_id: "my607jub",
      name: user.name,
      email: user.email,
      created_at: user.creationTime,
      user_hash: user.intercomHash,
      Resolution: window.screen.width + "x" + window.screen.height,
      "Screen Width": window.screen.width,
      "Screen Height": window.screen.height,
    };

    (function () {
      const w = window;
      const ic = w.Intercom;

      if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
      } else {
        const d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        // Show intercom window by default on /intercom (used by the gmail extension)
        if (window.location.pathname.includes("/intercom")) {
          w.Intercom("show");
        }
        const l = function () {
          const s = d.createElement("script");
          s.type = "text/javascript";
          s.async = true;
          s.src = "https://widget.intercom.io/widget/my607jub";
          const x = d.getElementsByTagName("script")[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") {
          l();
        } else if (w.attachEvent) {
          w.attachEvent("onload", l);
        } else {
          w.addEventListener("load", l, false);
        }
      }
    })();
  };

  // DELIGHTED

  !(function (e, t, r, n) {
    if (!e[n]) {
      for (
        var a = (e[n] = []),
          i = [
            "survey",
            "reset",
            "config",
            "init",
            "set",
            "get",
            "event",
            "identify",
            "track",
            "page",
            "screen",
            "group",
            "alias",
          ],
          s = 0;
        s < i.length;
        s++
      ) {
        var c = i[s];
        a[c] =
          a[c] ||
          (function (e) {
            return function () {
              var t = Array.prototype.slice.call(arguments);
              a.push([e, t]);
            };
          })(c);
      }
      a.SNIPPET_VERSION = "1.0.1";
      var o = t.createElement("script");
      ((o.type = "text/javascript"),
        (o.async = !0),
        (o.src =
          "https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/" +
          r +
          "/" +
          n +
          ".js"));
      var p = t.getElementsByTagName("script")[0];
      p.parentNode.insertBefore(o, p);
    }
  })(window, document, "74mBj8I8vKBDbQq1", "delighted");

  const delightedIdentifyUser = (user) => {
    if (window.location.pathname.startsWith("/signin")) return;
    delighted.survey({
      email: user.email,
      name: user.name,
      createdAt: user.creationTime,
      properties: { company: user.teamId },
    });
  };

  // BIRDIE

  const birdieIdentifyUser = (user) => {
    window.birdieSettings = {
      contact_name: user.name,
      contact_email: user.email,
      contact_id: user.userId,
    };

    window.addEventListener("load", function () {
      var t = document.createElement("script");
      ((t.type = "text/javascript"),
        (t.async = !0),
        (t.src = "https://app.birdie.so/widget/embed/ikw3vl20"),
        document.body.appendChild(t));
    });
  };

  // CLARITY

  const clarityIdentifyUser = (user) => {
    if (window.location.pathname.startsWith("/signin")) return;
    // only trigger consent if signed in and not already triggered (removed on sign out)
    if (localStorage.getItem("clarity") !== "active") {
      window.clarity("consentv2", {
        ad_Storage: "granted",
        analytics_Storage: "granted",
      });
      localStorage.setItem("clarity", "active");
    }
    window.clarity("identify", user.email);
  };

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", "8cblasg7oy");

  // HOTJAR

  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: 6477003, hjsv: 6 };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");

  const hotjarIdentifyUser = (user) => {
    window.hj("identify", user.email, {
      userId: user.userId,
      name: user.name,
      teamId: user.teamId,
      source: user.source,
    });
  };

  // GET USER

  const user = getUser();
  if (user && Object.keys(user).length) {
    intercomIdentifyUser(user);
    delightedIdentifyUser(user);
    birdieIdentifyUser(user);
    clarityIdentifyUser(user);
    hotjarIdentifyUser(user);
  } else {
    fetch("/api/users/get")
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((user) => {
        intercomIdentifyUser(user);
        delightedIdentifyUser(user);
        birdieIdentifyUser(user);
        clarityIdentifyUser(user);
        hotjarIdentifyUser(user);
      })
      .catch(() => {
        intercomIdentifyUser({});
      });
  }
};
